module.exports = __webpack_public_path__ + "static/media/washmechine.4583b922.jpg";